import React from "react";
import { Check, X } from "lucide-react";

/**
 * Status line for an integration (available / activated). Tailwind rebuild of
 * the old Chakra `IntegrationStatusRow` that used `AppIcon`.
 */
export const IntegrationStatusRow: React.FC<{
	activeTitle: string;
	inactiveTitle: string;
	status: boolean;
}> = ({ activeTitle, inactiveTitle, status }) => (
	<div className="flex items-center gap-2 text-sm">
		{status ? (
			<Check className="h-4 w-4 shrink-0 text-green-600" />
		) : (
			<X className="h-4 w-4 shrink-0 text-gray-400" />
		)}
		<span className="font-medium text-gray-700">{status ? activeTitle : inactiveTitle}</span>
	</div>
);
